// noinspection MagicNumberJS,DuplicatedCode
// No inspection for MagicNumber,DuplicatedCode because of Mocking
// - Remove no inspection once mocking is removed
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, delay, map } from "rxjs/operators";

import { ToastrService } from "ngx-toastr";

import { IPagedResponse } from "@aex/ngx-toolbox";

import { instanceToInstance, plainToInstance } from "class-transformer";

import {TableCacheService} from "./table-cache.service"; // Used for cacheing table data
import {PricingServiceApiService, SearchService} from "@aex/shared/apis";

import {
	getPromoStatusClass,
	TPromoStatus,
	getAreaStatusClass,
	getServiceStatusClass,
	generateRandomString, convertDateStringForGrid,
} from '../helpers';

import {
	AreaSearchRequestDto,
	BillingRuleRequestDto,
	BulkCustomerResponseDto,
	IPromoAppliedBy,
	IPromoBillingFrequency,
	IPromoBillingRule,
	IPromoCategory,
	IPromoCodeUsage,
	IPromoPeriodType,
	IPromoPriceReduction,
	IPromoReductionType,
	IPromoServiceStatus,
	ProductSearchRequestDto,
	PromoAreaTreeItem,
	PromoDiscountBulkCustomerRequestDto,
	PromoDiscountDataExportRequestDto,
	PromoDiscountDataItem,
	PromoDiscountDeleteRequestDto,
	PromoDiscountItem,
	PromoDiscountSearchRequestDto,
	PromoDiscountStatusItem,
	PromoProductItem as IPromoProduct,
	IPromotionDiscount,
	PromotionDiscount,
	IPromotionDiscountForService,
	PromotionDiscountForService,
	EnlistServiceByPromoIdRequestDto,
	IPromoRemovalReason,
	PromoRemovalReason,
	RemovePromoServiceRequestDto,
	PromoPriceReductionItem,
} from "../interfaces/promotion-discounts";

import {
	IColumnDto,
	IFullService,
	IPromoCustomerService,
	ISearchPagedResponse,
	IServiceSearchParams,
} from "../interfaces/search-service";
import { HttpResponse } from "@angular/common/http";

import {
	PromoReportSearchRequestDto,
	PromoReportSummaryDataExportRequestDto,
	PromoSummaryDto,
	PromoSummaryServiceDto,
	PromoSummaryServicePurchaseDto,
	PromoServicePurchaseInfoDto,
	PromoServicePurchaseDetailLineDto,
	PromoSummaryWithDataDto,
	PromoSummaryServiceWithDataDto,
	PromoDiscountFilterListRequestDto,
	EligibilityResponseDto,
	// PRICE_REDUCTION_BOLT_ON,
	PromoSummaryNestedInvoiceDto,
} from '@aex/shared/common-lib';
import { formatDate } from "@angular/common";

export const SERVICE_DELAY = 10;
export const TABLE_PROMO_PRICE_REDUCTION = 'PromoPriceReduction';				// To be deleted Morris
export const TABLE_PRICE_REDUCTION_PROMO = 'PriceReductionPromo';
export const TABLE_PRICE_REDUCTION_BOLT_ON = 'PriceReductionBoltOn';

export const TABLE_PROMO_BILLING_FREQUENCY = 'PromoBillingFrequency'; 	// To be deleted Morris
export const TABLE_BILLING_FREQUENCY_PROMO = 'BillingFrequencyPromo';
export const TABLE_BILLING_FREQUENCY_BOLT_ON = 'BillingFrequencyBoltOn';

export const TABLE_PROMO_CATEGORY = 'PromoCategory';										// To be deleted Morris
export const TABLE_CATEGORY_PROMO = 'CategoryPromo';
export const TABLE_CATEGORY_BOLT_ON = 'CategoryBoltOn';

export const TABLE_PROMO_REDUCTION_TYPE = 'PromoReductionType';					// To be deleted Morris
export const TABLE_REDUCTION_TYPE_PROMO = 'ReductionTypePromo';
export const TABLE_REDUCTION_TYPE_BOLT_ON = 'ReductionTypeBoltOn';

export const TABLE_PROMO_PERIOD_TYPE = 'PromoPeriodType';
export const TABLE_PROMO_CODE_USAGE = 'PromoCodeUsage';
export const TABLE_PROMO_APPLIED_BY = 'PromoAppliedBy';
export const TABLE_PROMO_AREA = 'PromoArea';
export const TABLE_PROMO_PRODUCT = 'PromoProduct';
export const TABLE_PROMO_BILLING_RULE = 'PromoBillingRule';
export const TABLE_PROMO_SERVICE_STATUS = 'PromoServiceStatus';
export const TABLE_PROMO_BILLING_STATUS = 'PromoBillingStatus';
export const TABLE_PROMOTION_DISCOUNT = 'PromotionDiscount';
export const TABLE_PROMOTION_DISCOUNT_STATUS = 'PromotionDiscountStatus';

export const SEARCH_SERVICE_COLUMN = 'SearchServiceColumn';

export const CUSTOMER_SERVICE_COLUMNS : string[]= [
	'Service: Id',
	'Customer: Full Name',
	'Customer: Email',
	'Premise: Full Address',
	'Area: Name',
	'Area: Area Status',
	'Service: Status',
	'Isp Product: Name',
];

@Injectable({
	providedIn: 'root',
})
export class PricingServiceService {

	private readonly USE_MOCK = false;

	constructor(
		private readonly toastr: ToastrService,
		private readonly tableCacheService: TableCacheService,
		private readonly pricingServiceApiService: PricingServiceApiService,
		private readonly searchService: SearchService,
	) {
		if (!this.tableCacheService.existTable(TABLE_PROMO_PERIOD_TYPE)) {
			// tableCacheService has not been initialized -- Seed the Cache
			if (this.USE_MOCK)
				this.getMockPromoPriceReductionList();
			if (this.USE_MOCK)
				this.getMockPromoBillingFrequencyList();
			if (this.USE_MOCK)
				this.getMockPromoCategoryList();
			if (this.USE_MOCK)
				this.getMockPromoReductionTypeList();

			this.getMockPromoPeriodTypeList();

			if (this.USE_MOCK)
				this.getMockPromoCodeUsageList();

			this.getMockPromoAppliedByList();         // Maybe deprecated due to Promo Code Form no longer used

			if (this.USE_MOCK)
				this.getMockPromoAreaList();              //
			if (this.USE_MOCK)
				this.getMockPromoProductList();
			if (this.USE_MOCK)
				this.getMockPromoBillingRuleList();
			// if (this.USE_MOCK) - always fetch the mocked servicestatusList for now
			this.getMockPromoServiceStatusList();

			this.initPromoDiscountData();

			this.seedPromoDiscountStatusData();
		}
	}

	//#region --- Promo Discount Lookup/Dropdown Data ---

	public getPriceReductionListForPromo(): Observable<IPromoPriceReduction[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<IPromoPriceReduction>(TABLE_PROMO_PRICE_REDUCTION).filter(r => r.code !== 'Bolt-On');
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const records = this.FetchCachedTableData<IPromoPriceReduction>(TABLE_PRICE_REDUCTION_PROMO);
		if (records.length > 0)
			return of(records).pipe(delay(SERVICE_DELAY));

		return this.pricingServiceApiService.getPriceReductionListForPromo().pipe(
			map((promoPriceReduction: IPromoPriceReduction[]) => {
				// Cache the data
				this.CacheTableData(TABLE_PRICE_REDUCTION_PROMO, promoPriceReduction);
				return promoPriceReduction;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching promo Price Reductions: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	public getPriceReductionListForBoltOn(): Observable<IPromoPriceReduction[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<IPromoPriceReduction>(TABLE_PROMO_PRICE_REDUCTION).filter(r => r.code === 'Bolt-On');
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const records = this.FetchCachedTableData<IPromoPriceReduction>(TABLE_PRICE_REDUCTION_BOLT_ON);
		if (records.length > 0)
			return of(records).pipe(delay(SERVICE_DELAY));

		return this.pricingServiceApiService.getPriceReductionListForBoltOn().pipe(
			map((promoPriceReduction: IPromoPriceReduction[]) => {
				// Cache the data
				this.CacheTableData(TABLE_PRICE_REDUCTION_BOLT_ON, promoPriceReduction);
				return promoPriceReduction;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching Bolt-On Price Reductions: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	// Get Promo Billing Frequency list / Price Type List
	// public getPromoBillingFrequencyList(): Observable<IPromoBillingFrequency[]> {
	// 	if (this.USE_MOCK) {
	// 		const records = this.tableCacheService.getAll<IPromoBillingFrequency>(TABLE_PROMO_BILLING_FREQUENCY);
	// 		return of(records).pipe(delay(SERVICE_DELAY));
	// 	}

	// 	// Check if the table has been cached
	// 	const records = this.FetchCachedTableData<IPromoBillingFrequency>(TABLE_PROMO_BILLING_FREQUENCY);
	// 	if (records.length > 0)
	// 		return of(records).pipe(delay(SERVICE_DELAY));

	// 	return this.pricingServiceApiService.getPromoBillingFrequencyList().pipe(
	// 		map((promoBillingFrequency: IPromoBillingFrequency[]) => {
	// 			// Cache the data
	// 			this.CacheTableData(TABLE_PROMO_BILLING_FREQUENCY, promoBillingFrequency);
	// 			return promoBillingFrequency;
	// 		}),
	// 		catchError((error) => {
	// 			this.toastr.error(`Error fetching promo Billing Frequencies: ${error.message || error}`);
	// 			return of([]); // Return an empty array as a fallback
	// 		}),
	// 	);
	// }
	public getBillingFrequencyListForPromo(): Observable<IPromoBillingFrequency[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<IPromoBillingFrequency>(TABLE_PROMO_BILLING_FREQUENCY);
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const records = this.FetchCachedTableData<IPromoBillingFrequency>(TABLE_BILLING_FREQUENCY_PROMO);
		if (records.length > 0)
			return of(records).pipe(delay(SERVICE_DELAY));

		return this.pricingServiceApiService.getBillingFrequencyListForPromo().pipe(
			map((promoBillingFrequency: IPromoBillingFrequency[]) => {
				// Cache the data
				this.CacheTableData(TABLE_BILLING_FREQUENCY_PROMO, promoBillingFrequency);
				return promoBillingFrequency;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching promo Billing Frequencies: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	public getBillingFrequencyListForBoltOn(): Observable<IPromoBillingFrequency[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<IPromoBillingFrequency>(TABLE_PROMO_BILLING_FREQUENCY).filter(r => r.code === 'Monthly');
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const records = this.FetchCachedTableData<IPromoBillingFrequency>(TABLE_BILLING_FREQUENCY_BOLT_ON);
		if (records.length > 0)
			return of(records).pipe(delay(SERVICE_DELAY));

		return this.pricingServiceApiService.getBillingFrequencyListForBoltOn().pipe(
			map((promoBillingFrequency: IPromoBillingFrequency[]) => {
				// Cache the data
				this.CacheTableData(TABLE_BILLING_FREQUENCY_BOLT_ON, promoBillingFrequency);
				return promoBillingFrequency;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching Bolt-On Billing Frequencies: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	public getCategoryListForPromo(): Observable<IPromoCategory[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<IPromoCategory>(TABLE_PROMO_CATEGORY).filter(r => r.promo_discount_type_id !== 3);
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const records = this.FetchCachedTableData<IPromoCategory>(TABLE_CATEGORY_PROMO);
		if (records.length > 0) {
			records.sort((a, b) => a.category_name.localeCompare(b.category_name));
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.getCategoryListForPromo().pipe(
			map((promoCategoryList: IPromoCategory[]) => {
				// Cache the data
				this.CacheTableData(TABLE_CATEGORY_PROMO, promoCategoryList);
				// Sort the list by category name
				promoCategoryList.sort((a, b) => a.category_name.localeCompare(b.category_name));

				return promoCategoryList;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching promo categories: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	public getCategoryListForBoltOn(): Observable<IPromoCategory[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<IPromoCategory>(TABLE_PROMO_CATEGORY).filter(r => r.promo_discount_type_id === 3);
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const records = this.FetchCachedTableData<IPromoCategory>(TABLE_CATEGORY_BOLT_ON);
		if (records.length > 0) {
			records.sort((a, b) => a.category_name.localeCompare(b.category_name));
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.getCategoryListForBoltOn().pipe(
			map((promoCategoryList: IPromoCategory[]) => {
				// Cache the data
				this.CacheTableData(TABLE_CATEGORY_BOLT_ON, promoCategoryList);
				// Sort the list by category name
				promoCategoryList.sort((a, b) => a.category_name.localeCompare(b.category_name));

				return promoCategoryList;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching Bolt-On categories: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	// Get Promo Reduction Type List
	public getReductionTypeListForPromo(): Observable<IPromoReductionType[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<IPromoReductionType>(TABLE_PROMO_REDUCTION_TYPE);
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const records = this.FetchCachedTableData<IPromoReductionType>(TABLE_REDUCTION_TYPE_PROMO);
		if (records.length > 0) {
			records.sort((a, b) => a.description.localeCompare(b.description));
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.getReductionTypeListForPromo().pipe(
			map((promoReductionTypeList: IPromoReductionType[]) => {
				// Cache the data
				this.CacheTableData(TABLE_REDUCTION_TYPE_PROMO, promoReductionTypeList);
				promoReductionTypeList.sort((a, b) => a.description.localeCompare(b.description));
				return promoReductionTypeList;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching promo Reduction Types: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}
	public getReductionTypeListForBoltOn(): Observable<IPromoReductionType[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<IPromoReductionType>(TABLE_PROMO_REDUCTION_TYPE).filter(r => r.code === 'Addition');
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const records = this.FetchCachedTableData<IPromoReductionType>(TABLE_REDUCTION_TYPE_BOLT_ON);
		if (records.length > 0) {
			records.sort((a, b) => a.description.localeCompare(b.description));
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.getReductionTypeListForBoltOn().pipe(
			map((promoReductionTypeList: IPromoReductionType[]) => {
				// Cache the data
				this.CacheTableData(TABLE_REDUCTION_TYPE_BOLT_ON, promoReductionTypeList);
				promoReductionTypeList.sort((a, b) => a.description.localeCompare(b.description));
				return promoReductionTypeList;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching Bolt-On Reduction Types: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	public getPromoPeriodTypeList(): Observable<IPromoPeriodType[]> {
		const records = this.tableCacheService.getAll<IPromoPeriodType>(TABLE_PROMO_PERIOD_TYPE);
		return of(records).pipe(delay(SERVICE_DELAY));
		// Dont know id Pricing Service has this API - It does not KR
		// For now use the mock? As always monthly?
		// return this.pricingServiceApiService.getPromoPeriodTypeList().pipe(
		//   map((promoPeriodTypeList: IPromoPeriodType[]) =>
		//     promoPeriodTypeList.sort((a, b) => a.name.localeCompare(b.name)),
		//   ),
		//   catchError((error) => {
		//     this.toastr.error(`Error fetching promo Period Types: ${error.message || error}`);
		//     return of([]); // Return an empty array as a fallback
		//   }),
		// );
	}

	public getPromoCodeUsageList(): Observable<IPromoCodeUsage[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<IPromoCodeUsage>(TABLE_PROMO_CODE_USAGE);
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const records = this.FetchCachedTableData<IPromoCodeUsage>(TABLE_PROMO_CODE_USAGE);
		if (records.length > 0) {
			records.sort((a, b) => a.name.localeCompare(b.name));
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.getPromoCodeUsageList().pipe(
			map((promoCodeUsageList: IPromoCodeUsage[]) => {
				// Cache the data
				this.CacheTableData(TABLE_PROMO_CODE_USAGE, promoCodeUsageList);
				promoCodeUsageList.sort((a, b) => a.name.localeCompare(b.name));
				return promoCodeUsageList;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching promo Code Usages: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	public getPromoAppliedByList(): Observable<IPromoAppliedBy[]> {
		// if (this.USE_MOCK) {
		const records = this.tableCacheService.getAll<IPromoAppliedBy>(TABLE_PROMO_APPLIED_BY);
		return of(records).pipe(delay(SERVICE_DELAY));
		// }

		// return this.pricingServiceApiService.getPromoAppliedByList().pipe(
		//   map((promoAppliedByList: IPromoAppliedBy[]) =>
		//     promoAppliedByList.sort((a, b) => a.name.localeCompare(b.name)),
		//   ),
		//   catchError((error) => {
		//     this.toastr.error(`Error fetching promo Applied By list: ${error.message || error}`);
		//     return of([]); // Return an empty array as a fallback
		//   }),
		// );
	}

	public getPromoAreaList(areaSearchRequestDto: AreaSearchRequestDto): Observable<PromoAreaTreeItem[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<PromoAreaTreeItem>(TABLE_PROMO_AREA);
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const canCache = (areaSearchRequestDto.product_ids.length === 0) && (areaSearchRequestDto.billing_rule_ids.length === 0);
		if (canCache) {
			// Check if the table has been cached
			const records = this.FetchCachedTableData<PromoAreaTreeItem>(TABLE_PROMO_AREA);
			if (records.length > 0) {
				const sortedData = this.sortTree(records);
				return of(sortedData).pipe(delay(SERVICE_DELAY));
			}
		}

		return this.pricingServiceApiService.getPromoAreaList(areaSearchRequestDto).pipe(
			map((promoAreaList: PromoAreaTreeItem[]) => {
				// Cache the data if applicable
				if (canCache)
					this.CacheTableData(TABLE_PROMO_AREA, promoAreaList);

				// Sort the tree
				// Return the processed list
				return this.sortTree(promoAreaList);
			}),
			catchError((error) => {
				// Handle errors and provide fallback
				this.toastr.error(`Error fetching promo Area list: ${error.message || error}`);
				return of([]); // Return an empty array as fallback
			}),
		);
	}

	public getPromoProductList(productSearchRequestDto: ProductSearchRequestDto): Observable<IPromoProduct[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<IPromoProduct>(TABLE_PROMO_PRODUCT);
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const canCache = (productSearchRequestDto.area_ids.length === 0) && (productSearchRequestDto.billing_rule_ids.length === 0);
		if (canCache) {
			// Check if the table has been cached
			const records = this.FetchCachedTableData<IPromoProduct>(TABLE_PROMO_PRODUCT);
			if (records.length > 0) {
				records.sort((a, b) => a.name.localeCompare(b.name));
				return of(records).pipe(delay(SERVICE_DELAY));
			}
		}

		return this.pricingServiceApiService.getPromoProductList(productSearchRequestDto).pipe(
			map((promoProductList: IPromoProduct[]) => {
				// If the data can be cached, cache it
				if (canCache)
					this.CacheTableData(TABLE_PROMO_PRODUCT, promoProductList);

				promoProductList.sort((a, b) => a.name.localeCompare(b.name));
				return promoProductList;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching promo Product list: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	// Get Promo Billing Rule List
	public getPromoBillingRuleList(billingRuleRequestDto: BillingRuleRequestDto): Observable<IPromoBillingRule[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<IPromoBillingRule>(TABLE_PROMO_BILLING_RULE);
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const canCache = (billingRuleRequestDto.area_ids.length === 0) && (billingRuleRequestDto.product_ids.length === 0);
		if (canCache) {
			// Check if the table has been cached
			const records = this.FetchCachedTableData<IPromoBillingRule>(TABLE_PROMO_BILLING_RULE);
			if (records.length > 0) {
				records.sort((a, b) => a.name.localeCompare(b.name));
				return of(records).pipe(delay(SERVICE_DELAY));
			}
		}

		return this.pricingServiceApiService.getPromoBillingRuleList(billingRuleRequestDto).pipe(
			map((promoBillingRuleList: IPromoBillingRule[]) => {
				// Cache the data if applicable
				if (canCache)
					this.CacheTableData(TABLE_PROMO_BILLING_RULE, promoBillingRuleList);

				// Sort the data
				promoBillingRuleList.sort((a, b) => a.name.localeCompare(b.name));

				return promoBillingRuleList;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching promo Billing Rule List: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	// Get Promo Service Status List
	public getPromoServiceStatusList(): Observable<IPromoServiceStatus[]> {
		if (this.USE_MOCK) {
			const records = this.tableCacheService.getAll<IPromoServiceStatus>(TABLE_PROMO_SERVICE_STATUS);
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		// Check if the table has been cached
		const records = this.FetchCachedTableData<IPromoServiceStatus>(TABLE_PROMO_SERVICE_STATUS);
		if (records.length > 0) {
			records.sort((a, b) => a.name.localeCompare(b.name));
			return of(records).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.getPromoServiceStatusList().pipe(
			map((promoServiceStatusList: IPromoServiceStatus[]) => {
				// Cache the data
				this.CacheTableData(TABLE_PROMO_SERVICE_STATUS, promoServiceStatusList);
				promoServiceStatusList.sort((a, b) => a.name.localeCompare(b.name));
				return promoServiceStatusList;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching promo Service Status List: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	// Get Promo Billing Status List
	// public getPromoBillingStatusList(): Observable<IPromoBillingStatus[]> {
	//     const records = this.tableCacheService.getAll<IPromoBillingStatus>(TABLE_PROMO_BILLING_STATUS);
	//     return of(records).pipe(delay(SERVICE_DELAY));
	//
	//   // return this.pricingServiceApiService.getPromoBillingStatusList().pipe(
	//   //   map((promoBillingStatusList: IPromoServiceStatus[]) =>
	//   //     promoBillingStatusList.sort((a, b) => a.name.localeCompare(b.name)),
	//   //   ),
	//   //   catchError((error) => {
	//   //     this.toastr.error(`Error fetching promo Billing Status List: ${error.message || error}`);
	//   //     return of([]); // Return an empty array as a fallback
	//   //   }),
	//   // );
	// }

	public getPromoDiscountStatusList(): PromoDiscountStatusItem[] {
		const records = this.tableCacheService.getAll<PromoDiscountStatusItem>(TABLE_PROMOTION_DISCOUNT_STATUS);
		return [...records];
	}

	private sortTree(treeList: PromoAreaTreeItem[]): PromoAreaTreeItem[] {
		return treeList
			.map(node => ({
				...node,
				children: node.children?.length ? this.sortTree(node.children) : node.children, // Only sort if children exist
			}))
			.sort((a, b) => a.name.localeCompare(b.name)); // Sort after processing children
	}

	private CacheTableData<T extends { id: number|string }>(table: string, data: T[]): void {
		data.map((record : T) => this.tableCacheService.set(table, record.id, record));
	}

	private FetchCachedTableData<T>(table: string): T[] {
		return this.tableCacheService.existTable(table) ? this.tableCacheService.getAll<T>(table) : [];
	}

	//#endregion --- Promo Discount Lookup/Dropdown Data ---

	//#region --- Promo Discount Data ---

	public getPromotionDiscountData(searchRequest: PromoDiscountSearchRequestDto): Observable<IPagedResponse<PromoDiscountDataItem>> {
		// if (this.USE_MOCK)
		// 	return this.getMockPromotionDiscountData(searchRequest);

		return this.pricingServiceApiService.getPromotionDiscountData(searchRequest).pipe(
			map((response: IPagedResponse<PromoDiscountDataItem>) => {
				// Transform each item to add status and promo_status_class
				const updatedItems = response.items.map(
					(promoDiscountDataItem: PromoDiscountDataItem) => ({
						...promoDiscountDataItem,
						start_date_value: convertDateStringForGrid(promoDiscountDataItem.start_date),
						end_date_value: promoDiscountDataItem.end_date
							? convertDateStringForGrid(promoDiscountDataItem.end_date)
							: null,
						published_date: promoDiscountDataItem.published_date
							? convertDateStringForGrid(promoDiscountDataItem.end_date)
							: null,
						promo_status_class: getPromoStatusClass(promoDiscountDataItem.status),
					}),
				);

				// Sort the updated items by name
				const sortedItems = updatedItems.sort((a, b) => a.name.localeCompare(b.name));

				// Return the updated response with sorted items
				return {
					...response,
					items: sortedItems,
				};
			}),
			catchError(() => {
				this.toastr.error(`Error fetching promo discounts. Please try again later.`);
				return of({items: [], page: searchRequest.page_number, count: 0, total: 0}); // Return an empty array as a fallback
			}),
		);

	}

	public deletePromotions(deleteRequest: PromoDiscountDeleteRequestDto): Observable<boolean> {
		if (this.USE_MOCK) {
			deleteRequest.promo_discount_ids.forEach((promoId: string) => {
				const recordExists = this.tableCacheService.has(TABLE_PROMOTION_DISCOUNT, promoId);
				if (recordExists) {
					const promoDiscountItem = this.tableCacheService.get<PromoDiscountItem>(TABLE_PROMOTION_DISCOUNT, promoId);
					promoDiscountItem.promo_discount_status_id = TPromoStatus.Deleted;
					this.tableCacheService.set(TABLE_PROMOTION_DISCOUNT, promoId, promoDiscountItem);
				}
			});
			return of(true);
		}

		return this.pricingServiceApiService.deletePromotions(deleteRequest).pipe(
			map(() => true),
			catchError((error) => {
				this.toastr.error(`Error deleting promo discounts: ${error.error.detail || error}`);
				return of(false); // Return an empty array as a fallback
			}),
		);
	}

	public getPromotionDiscountById(promoId: string): Observable<PromoDiscountItem> {
		if (this.USE_MOCK) {
			const response = this.tableCacheService.get<PromoDiscountItem>(TABLE_PROMOTION_DISCOUNT, promoId);
			if ((!response.promo_discount_detail_item.promo_is_perpetual) &&
				(!response.promo_discount_detail_item.promo_end_date_value))
				response.promo_discount_detail_item.promo_end_date_value = new Date();
			return of(response).pipe(delay(SERVICE_DELAY));
		}
		return this.pricingServiceApiService.getPromotionDiscountById(promoId).pipe(
			map((response: PromoDiscountItem) => {
				// Convert data to class since the class has methods
				const result = plainToInstance(PromoDiscountItem, response);
				result.promo_discount_detail_item.promo_code = result.promo_discount_detail_item.promo_code;
				return result;
			}),
			catchError((error) => {
				this.toastr.error(`getPromotionDiscountById error: ${error.error.detail || error}`);
				return of(null); // Return an empty array as a fallback
			}),
		);
	}

	public createPromotionDiscount(promoDiscountItem: PromoDiscountItem): Observable<PromoDiscountItem> {
		if (this.USE_MOCK) {
			const key = generateRandomString(36);
			promoDiscountItem.promo_discount_id = key;
			const clone = instanceToInstance(promoDiscountItem);
			this.tableCacheService.set(TABLE_PROMOTION_DISCOUNT, key, clone);
			return of(clone).pipe(delay(SERVICE_DELAY));
		}
		return this.pricingServiceApiService.createPromotionDiscount(promoDiscountItem).pipe(
			map((response: PromoDiscountItem) =>
				// Convert data to class since the class has methods
				plainToInstance(PromoDiscountItem, response),
			),
			catchError((error) => {
				this.toastr.error(`createPromotionDiscount error: ${error.error || error}`);
				throw new Error(`Error creating promo discount`);
			}),
		);
	}

	public updatePromotionDiscount(promoDiscountItem: PromoDiscountItem): Observable<PromoDiscountItem> {
		if (this.USE_MOCK) {
			const key = promoDiscountItem.promo_discount_id;
			const clone = instanceToInstance(promoDiscountItem);
			this.tableCacheService.set(TABLE_PROMOTION_DISCOUNT, key, clone);
			return of(clone).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.updatePromotionDiscount(promoDiscountItem).pipe(
			map((response: PromoDiscountItem) =>
				// Convert data to class since the class has methods
				plainToInstance(PromoDiscountItem, response),
			),
			catchError((error) => {
				this.toastr.error(`updatePromotionDiscount error: ${error.error || error}`);
				throw new Error(`Error updating promo discounts`);
			}),
		);
	}

	public bulkAddCustomerPromoDiscount(promoId: string, updateRequestDto: PromoDiscountBulkCustomerRequestDto): Observable<BulkCustomerResponseDto> {
		if (this.USE_MOCK) {
			const result = new BulkCustomerResponseDto();
			result.promo_id = promoId;
			result.services_updated = [...updateRequestDto.entity_service_ids];
			result.services_deleted = [];
			return of(result).pipe(delay(SERVICE_DELAY));
		}
		return this.pricingServiceApiService.bulkAddCustomerPromoDiscount(promoId, updateRequestDto).pipe(
			map((response: BulkCustomerResponseDto) =>
				// Convert data to class since the class has methods
				plainToInstance(BulkCustomerResponseDto, response),
			),
			catchError((error) => {
				this.toastr.error(`bulkAddCustomerPromoDiscount error: ${error.message || error}`);
				throw new Error(`Error bulkAddCustomerPromoDiscount`);
			}),
		);
	}

	public bulkDeleteCustomerPromoDiscount(promoId: string, updateRequestDto: PromoDiscountBulkCustomerRequestDto): Observable<BulkCustomerResponseDto> {
		if (this.USE_MOCK) {
			const result = new BulkCustomerResponseDto();
			result.promo_id = promoId;
			result.services_updated = [...updateRequestDto.entity_service_ids];
			result.services_deleted = [];
			return of(result).pipe(delay(SERVICE_DELAY));
		}
		return this.pricingServiceApiService.bulkDeleteCustomerPromoDiscount(promoId, updateRequestDto).pipe(
			map((response: BulkCustomerResponseDto) =>
				// Convert data to class since the class has methods
				plainToInstance(BulkCustomerResponseDto, response),
			),
			catchError((error) => {
				this.toastr.error(`bulkDeleteCustomerPromoDiscount error: ${error.message || error}`);
				throw new Error(`Error bulkDeleteCustomerPromoDiscount`);
			}),
		);
	}

	public exportPromotionDiscountData(promoDiscountDataExportRequestDto: PromoDiscountDataExportRequestDto): Observable<HttpResponse<Blob>> {
		if (this.USE_MOCK) {
			// Mock the export
			const dummyBlob = new Blob(['Mocking Dummy promo export data'], { type: 'text/csv' });
			const dummyResponse = new HttpResponse({
				body: dummyBlob,
				status: 200,
			});
			return of(dummyResponse).pipe(delay(SERVICE_DELAY));
		}
		// Call the API
		return this.pricingServiceApiService.exportPromotionDiscountData(promoDiscountDataExportRequestDto);
	}

	public getPromotionDiscountReportById(promoId: string): Observable<PromoDiscountDataItem> {
		// if (this.USE_MOCK) {
		// 	const response = this.tableCacheService.get<PromoDiscountItem>(TABLE_PROMOTION_DISCOUNT, promoId);
		// 	const result = this.transformPromoDiscountItemToPromoDiscountDataItem(response);
		// 	return of(result).pipe(delay(SERVICE_DELAY));
		// }

		return this.pricingServiceApiService.getPromotionDiscountReportById(promoId).pipe(
			map((response: PromoDiscountDataItem) => {
				return response;
			}),
			catchError((error) => {
				this.toastr.error(`getPromotionDiscountByReportId error: ${error.message || error}`);
				return of(new PromoDiscountDataItem()); // Return an empty array as a fallback
			}),
		);
	}

	//#endregion --- Promo Discount Data ---

	//#region --- Bolt-on Data ---

	public getBoltOnData(searchRequest: PromoDiscountSearchRequestDto): Observable<IPagedResponse<PromoDiscountDataItem>> {
		// if (this.USE_MOCK)
		// 	return this.getMockBoltOnData(searchRequest);

		return this.pricingServiceApiService.getBoltOnData(searchRequest).pipe(
			map((response: IPagedResponse<PromoDiscountDataItem>) => {
				// Transform each item to add status and promo_status_class
				const updatedItems = response.items.map(
					(promoDiscountDataItem: PromoDiscountDataItem) => ({
						...promoDiscountDataItem,
						start_date_value: convertDateStringForGrid(promoDiscountDataItem.start_date),
						end_date_value: (promoDiscountDataItem.end_date)
							? convertDateStringForGrid(promoDiscountDataItem.end_date)
							: null,
						published_date: (promoDiscountDataItem.published_date) ? new Date(promoDiscountDataItem.published_date) : null,
						promo_status_class: getPromoStatusClass(promoDiscountDataItem.status),
					}),
				);

				// Sort the updated items by name
				const sortedItems = updatedItems.sort((a, b) => a.name.localeCompare(b.name));

				// Return the updated response with sorted items
				return {
					...response,
					items: sortedItems,
				};
			}),
			catchError(() => {
				this.toastr.error(`Error fetching bolt-on data. Please try again later.`);
				return of({items: [], page: searchRequest.page_number, count: 0, total: 0}); // Return an empty array as a fallback
			}),
		);

	}

	public createBoltOn(promoDiscountItem: PromoDiscountItem): Observable<PromoDiscountItem> {
		if (this.USE_MOCK) {
			const key = generateRandomString(36);
			promoDiscountItem.promo_discount_id = key;
			const clone = instanceToInstance(promoDiscountItem);
			this.tableCacheService.set(TABLE_PROMOTION_DISCOUNT, key, clone);
			return of(clone).pipe(delay(SERVICE_DELAY));
		}
		return this.pricingServiceApiService.createBoltOn(promoDiscountItem).pipe(
			map((response: PromoDiscountItem) =>
				// Convert data to class since the class has methods
				plainToInstance(PromoDiscountItem, response),
			),
			catchError((error) => {
				this.toastr.error(`createBoltOn error: ${error.error || error}`);
				throw new Error(`Error creating bolt-on`);
			}),
		);
	}

	public updateBoltOn(promoDiscountItem: PromoDiscountItem): Observable<PromoDiscountItem> {
		if (this.USE_MOCK) {
			const key = promoDiscountItem.promo_discount_id;
			const clone = instanceToInstance(promoDiscountItem);
			this.tableCacheService.set(TABLE_PROMOTION_DISCOUNT, key, clone);
			return of(clone).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.updateBoltOn(promoDiscountItem).pipe(
			map((response: PromoDiscountItem) =>
				// Convert data to class since the class has methods
				plainToInstance(PromoDiscountItem, response),
			),
			catchError((error) => {
				this.toastr.error(`updateBoltOn error: ${error.error || error}`);
				throw new Error(`Error updating Bolt-On`);
			}),
		);
	}

	public deleteBoltOns(deleteRequest: PromoDiscountDeleteRequestDto): Observable<boolean> {
		if (this.USE_MOCK) {
			deleteRequest.promo_discount_ids.forEach((promoId: string) => {
				const recordExists = this.tableCacheService.has(TABLE_PROMOTION_DISCOUNT, promoId);
				if (recordExists) {
					const promoDiscountItem = this.tableCacheService.get<PromoDiscountItem>(TABLE_PROMOTION_DISCOUNT, promoId);
					promoDiscountItem.promo_discount_status_id = TPromoStatus.Deleted;
					this.tableCacheService.set(TABLE_PROMOTION_DISCOUNT, promoId, promoDiscountItem);
				}
			});
			return of(true);
		}

		return this.pricingServiceApiService.deleteBoltOns(deleteRequest).pipe(
			map(() => true),
			catchError((error) => {
				this.toastr.error(`Error deleting bolt-ons: ${error.error.detail || error}`);
				return of(false); // Return an empty array as a fallback
			}),
		);
	}

	public getBoltOnById(promoId: string): Observable<PromoDiscountItem> {
		if (this.USE_MOCK) {
			const response = this.tableCacheService.get<PromoDiscountItem>(TABLE_PROMOTION_DISCOUNT, promoId);
			if ((!response.promo_discount_detail_item.promo_is_perpetual) &&
				(!response.promo_discount_detail_item.promo_end_date_value))
				response.promo_discount_detail_item.promo_end_date_value = new Date();
			return of(response).pipe(delay(SERVICE_DELAY));
		}
		return this.pricingServiceApiService.getBoltOnById(promoId).pipe(
			map((response: PromoDiscountItem) => {
				// Convert data to class since the class has methods
				const result = plainToInstance(PromoDiscountItem, response);
				result.promo_discount_detail_item.promo_code = result.promo_discount_detail_item.promo_code;
				return result;
			}),
			catchError((error) => {
				this.toastr.error(`getBoltOnById error: ${error.error.detail || error}`);
				return of(null); // Return an empty array as a fallback
			}),
		);
	}

	public exportBoltOnData(promoDiscountDataExportRequestDto: PromoDiscountDataExportRequestDto): Observable<HttpResponse<Blob>> {
		if (this.USE_MOCK) {
			// Mock the export
			const dummyBlob = new Blob(['Mocking Dummy Bolt-On export data'], { type: 'text/csv' });
			const dummyResponse = new HttpResponse({
				body: dummyBlob,
				status: 200,
			});
			return of(dummyResponse).pipe(delay(SERVICE_DELAY));
		}
		// Call the API
		return this.pricingServiceApiService.exportBoltOnData(promoDiscountDataExportRequestDto);
	}

	public bulkAddCustomerBoltOn(promoId: string, updateRequestDto: PromoDiscountBulkCustomerRequestDto): Observable<BulkCustomerResponseDto> {
		if (this.USE_MOCK) {
			const result = new BulkCustomerResponseDto();
			result.promo_id = promoId;
			result.services_updated = [...updateRequestDto.entity_service_ids];
			result.services_deleted = [];
			return of(result).pipe(delay(SERVICE_DELAY));
		}
		return this.pricingServiceApiService.bulkAddCustomerBoltOn(promoId, updateRequestDto).pipe(
			map((response: BulkCustomerResponseDto) =>
				// Convert data to class since the class has methods
				plainToInstance(BulkCustomerResponseDto, response),
			),
			catchError((error) => {
				this.toastr.error(`bulkAddCustomerBoltOn error: ${error.message || error}`);
				throw new Error(`Error bulkAddCustomerBoltOn`);
			}),
		);
	}

	public bulkDeleteCustomerBoltOn(promoId: string, updateRequestDto: PromoDiscountBulkCustomerRequestDto): Observable<BulkCustomerResponseDto> {
		if (this.USE_MOCK) {
			const result = new BulkCustomerResponseDto();
			result.promo_id = promoId;
			result.services_updated = [...updateRequestDto.entity_service_ids];
			result.services_deleted = [];
			return of(result).pipe(delay(SERVICE_DELAY));
		}
		return this.pricingServiceApiService.bulkDeleteCustomerBoltOn(promoId, updateRequestDto).pipe(
			map((response: BulkCustomerResponseDto) =>
				// Convert data to class since the class has methods
				plainToInstance(BulkCustomerResponseDto, response),
			),
			catchError((error) => {
				this.toastr.error(`bulkDeleteCustomerBoltOn error: ${error.message || error}`);
				throw new Error(`Error bulkDeleteCustomerBoltOn`);
			}),
		);
	}

	public getServiceBoltOnWithData(searchRequest: PromoReportSearchRequestDto) : Observable<IPagedResponse<PromoSummaryWithDataDto>> {
		return this.pricingServiceApiService.getServiceBoltOnWithData(searchRequest);
	}

	public getBoltOnSelectionListToAddService(serviceId : string) : Observable<IPromotionDiscountForService[]> {
		return this.pricingServiceApiService.getBoltOnSelectionListToAddService(serviceId).pipe(
			map((promoSelectionList: IPromotionDiscountForService[]) => {
				const records = plainToInstance(PromotionDiscountForService, promoSelectionList);
				records.sort((a, b) => a.name.localeCompare(b.name));
				return records;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching promo selection list to add service: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

  public enlistServiceByBoltOnId(serviceId: string, promoId: string, promoDate: Date) : Observable<EligibilityResponseDto> {
		// Build the request object
	  const request = new EnlistServiceByPromoIdRequestDto();
		request.promo_discount_id = promoId.toLowerCase();
		request.service_id = serviceId.toLowerCase();
		request.enlistment_start_date = promoDate;

		return this.pricingServiceApiService.enlistServiceByBoltOnId(request).pipe(
			catchError((error) => {
				this.toastr.error(`enlistServiceByPromoId error: ${error.error || error}`);
				return of(null);
			}),
		);
	}

	public getBoltOnReportSummary(searchRequest: PromoReportSearchRequestDto) : Observable<IPagedResponse<PromoSummaryDto>> {
		return this.pricingServiceApiService.getBoltOnReportSummaryData(searchRequest);
	}

	public exportBoltOnReportSummary(promoReportSummaryDataExportRequestDto: PromoReportSummaryDataExportRequestDto) : Observable<HttpResponse<Blob>>  {
		if (this.USE_MOCK) {
			// Mock the export
			const dummyBlob = new Blob(['Mocking Dummy Bolt-on export data'], {type: 'text/csv'});
			const dummyResponse = new HttpResponse({
				body: dummyBlob,
				status: 200,
			});
			return of(dummyResponse).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.getBoltOnReportSummaryExportData(promoReportSummaryDataExportRequestDto);
  }

	public getBoltOnReportSummaryServicePurchases(searchRequest: PromoReportSearchRequestDto) : Observable<IPagedResponse<PromoSummaryServicePurchaseDto>> {
		return this.pricingServiceApiService.getBoltOnReportSummaryServicePurchases(searchRequest);
	}

	public exportBoltOnReportSummaryServicePurchases(promoReportSummaryDataExportRequestDto: PromoReportSummaryDataExportRequestDto) : Observable<HttpResponse<Blob>>  {
		if (this.USE_MOCK) {
			// Mock the export
			const dummyBlob = new Blob(['Mocking Dummy Bolt-On export summary service purchase data'], {type: 'text/csv'});
			const dummyResponse = new HttpResponse({
				body: dummyBlob,
				status: 200,
			});
			return of(dummyResponse).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.getBoltOnReportSummaryServicePurchasesExportData(promoReportSummaryDataExportRequestDto);
	}

	public getBoltOnReportSummaryServices(searchRequest: PromoReportSearchRequestDto) : Observable<IPagedResponse<PromoSummaryServiceDto>> {
		return this.pricingServiceApiService.getBoltOnReportServiceSummaryData(searchRequest);
	}

	public getBoltOnReportSummaryServicePurchaseInfo(
		searchRequest: PromoReportSearchRequestDto,
	) : Observable<PromoServicePurchaseInfoDto> {
		return this.pricingServiceApiService.getPromoReportSummaryServicePurchaseInfoData(searchRequest);
	}

	//#endregion --- Bolt-on Data ---

	//#region --- Customer Data ---

	// Get the ColumnDto for the Customer Service Grid
	public getGridServiceColumns(): Observable<IColumnDto[]> {
		const requiredColumns: IColumnDto[] = [];
		return this.searchService.getServiceColumns().pipe(
			map((response) => {
				const columns: IColumnDto[] = response.body;
				// Iterate over the CUSTOMER_SERVICE_COLUMNS and extract the corresponding grid column
				CUSTOMER_SERVICE_COLUMNS.forEach((column: string) => {
					const columnDto: IColumnDto = columns.find((columnDto) => columnDto.heading === column);
					if (columnDto)
						requiredColumns.push(columnDto);
				});
				return requiredColumns;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching customer columns: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	public getCustomerServices(request: Partial<IServiceSearchParams>): Observable<ISearchPagedResponse> {
		return this.searchService.getServices(request).pipe(
			map((response) => {
				const responseData: ISearchPagedResponse = response.body;
				const promoCustomerServiceData: IPromoCustomerService[] = this.transformToPromoCustomerServiceDto(responseData.items);
				const result: ISearchPagedResponse = {
					items: promoCustomerServiceData,
					page: responseData.page,
					count: responseData.count,
					total: responseData.total,
					sort_field: responseData.sort_field,
					sort_order: responseData.sort_order,
				};
				return result;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching customer services: ${error.message || error}`);
				return of(null);
			}),
		);
	}

	//#endregion --- Customer Data ---

	//#region --- Promo Discount Report Data ---

	public getPromoReportSummary(searchRequest: PromoReportSearchRequestDto) : Observable<IPagedResponse<PromoSummaryDto>> {
		if (this.USE_MOCK)
			return this.getMockPromoReportSummaryData(searchRequest);

		return this.pricingServiceApiService.getPromotionReportSummaryData(searchRequest);
	}

	public getPromoReportSummaryServices(searchRequest: PromoReportSearchRequestDto) : Observable<IPagedResponse<PromoSummaryServiceDto>> {
		if (this.USE_MOCK)
			return this.getMockPromoReportSummaryServicesData(searchRequest);

		return this.pricingServiceApiService.getPromotionReportServiceSummaryData(searchRequest);
	}

	public getPromoReportSummaryServicePurchases(searchRequest: PromoReportSearchRequestDto) : Observable<IPagedResponse<PromoSummaryServicePurchaseDto>> {
		if (this.USE_MOCK)
			return this.getMockPromoReportSummaryServicePurchasesData(searchRequest);

		return this.pricingServiceApiService.getPromoReportSummaryServicePurchases(searchRequest);
	}

	public getPromoReportSummaryServicePurchaseInfo(
		promoSummaryServicePurchaseDto : PromoSummaryServicePurchaseDto,
		searchRequest: PromoReportSearchRequestDto,
	) : Observable<PromoServicePurchaseInfoDto> {
		if (this.USE_MOCK)
			return this.getMockPromoReportSummaryServicePurchaseInfoData(promoSummaryServicePurchaseDto, searchRequest);

		return this.pricingServiceApiService.getPromoReportSummaryServicePurchaseInfoData(searchRequest);
	}

	public getServicePromoWithData(searchRequest: PromoReportSearchRequestDto) : Observable<IPagedResponse<PromoSummaryWithDataDto>> {
		if (this.USE_MOCK)
			return this.getMockServicePromoWithData(searchRequest);

		return this.pricingServiceApiService.getServicePromoWithData(searchRequest);
	}

	public getBoltOnExhaustReasons() : Observable<IPromoRemovalReason[]> {
		return this.pricingServiceApiService.getBoltOnExhaustReasons().pipe(
			map((promoRemovalReasonList: IPromoRemovalReason[]) => {
				const records = plainToInstance(PromoRemovalReason, promoRemovalReasonList);
				records.sort((a, b) => a.name.localeCompare(b.name));
				return records;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching Bolt-On removal reasons: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

  public removeBoltOnFromService(request : RemovePromoServiceRequestDto) : Observable<void> {

		return this.pricingServiceApiService.removeBoltOnFromService(request).pipe(
			catchError((error) => {
				this.toastr.error(`removeBoltOnFromService error: ${error.error || error}`);
				return of(null);
			}),
		);
	}

	public exportBoltOnReportSummaryServices(promoReportSummaryDataExportRequestDto: PromoReportSummaryDataExportRequestDto) : Observable<HttpResponse<Blob>>  {
		if (this.USE_MOCK) {
			// Mock the export
			const dummyBlob = new Blob(['Mocking Dummy Bolt-On export summary service data'], {type: 'text/csv'});
			const dummyResponse = new HttpResponse({
				body: dummyBlob,
				status: 200,
			});
			return of(dummyResponse).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.getBoltOnReportServiceSummaryExportData(promoReportSummaryDataExportRequestDto);
	}

	// Get list of Promotions for PromoReports
	public getPromoSelectionList(
		searchRequest: PromoDiscountFilterListRequestDto,
	) : Observable<IPromotionDiscount[]> {
		if (this.USE_MOCK)
			return this.getMockPromoSelectionList();

		return this.pricingServiceApiService.getPromoSelectionList(searchRequest).pipe(
			map((promoSelectionList: IPromotionDiscount[]) => {
				const records = plainToInstance(PromotionDiscount, promoSelectionList);
				records.sort((a, b) => a.name.localeCompare(b.name));
				return records;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching promo selection list: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	public getBoltOnSelectionList(
		searchRequest: PromoDiscountFilterListRequestDto,
	) : Observable<IPromotionDiscount[]> {
		if (this.USE_MOCK)
			return this.getMockPromoSelectionList();

		return this.pricingServiceApiService.getBoltOnSelectionList(searchRequest).pipe(
			map((promoSelectionList: IPromotionDiscount[]) => {
				const records = plainToInstance(PromotionDiscount, promoSelectionList);
				records.sort((a, b) => a.name.localeCompare(b.name));
				return records;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching bolt-on selection list: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

	public getPromoSelectionListToAddService(serviceId : string) : Observable<IPromotionDiscountForService[]> {
		if (this.USE_MOCK)
			return this.getMockPromoSelectionListToAddService();

		return this.pricingServiceApiService.getPromoSelectionListToAddService(serviceId).pipe(
			map((promoSelectionList: IPromotionDiscountForService[]) => {
				const records = plainToInstance(PromotionDiscountForService, promoSelectionList);
				records.sort((a, b) => a.name.localeCompare(b.name));
				return records;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching promo selection list to add service: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

  public enlistServiceByPromoId(serviceId: string, promoId: string, promoDate: Date) : Observable<boolean> {
		if (this.USE_MOCK)
			return of(null).pipe(delay(SERVICE_DELAY)); // Mocking the delay for the request

		// Build the request object
	  const request = new EnlistServiceByPromoIdRequestDto();
		request.promo_discount_id = promoId.toLowerCase();
		request.service_id = serviceId.toLowerCase();
		request.enlistment_start_date = promoDate;

		return this.pricingServiceApiService.enlistServiceByPromoId(request).pipe(
			catchError((error) => {
				this.toastr.error(`enlistServiceByPromoId error: ${error.error || error}`);
				return of(null);
			}),
		);
	}

	public getPromoExhaustReasons() : Observable<IPromoRemovalReason[]> {
		if (this.USE_MOCK)
			return this.getMockPromoRemovalReasonList();

		return this.pricingServiceApiService.getPromoExhaustReasons().pipe(
			map((promoRemovalReasonList: IPromoRemovalReason[]) => {
				const records = plainToInstance(PromoRemovalReason, promoRemovalReasonList);
				records.sort((a, b) => a.name.localeCompare(b.name));
				return records;
			}),
			catchError((error) => {
				this.toastr.error(`Error fetching promo removal reason list: ${error.message || error}`);
				return of([]); // Return an empty array as a fallback
			}),
		);
	}

  public removePromoFromService(request : RemovePromoServiceRequestDto) : Observable<void> {
		// Build the request object
		if (this.USE_MOCK)
			return of(null).pipe(delay(SERVICE_DELAY)); // Mocking the delay for the request

		return this.pricingServiceApiService.removePromoFromService(request).pipe(
			catchError((error) => {
				this.toastr.error(`removePromoFromService error: ${error.error || error}`);
				return of(null);
			}),
		);
	}

	public exportPromoReportSummary(promoReportSummaryDataExportRequestDto: PromoReportSummaryDataExportRequestDto) : Observable<HttpResponse<Blob>>  {
		if (this.USE_MOCK) {
			// Mock the export
			const dummyBlob = new Blob(['Mocking Dummy promo export data'], {type: 'text/csv'});
			const dummyResponse = new HttpResponse({
				body: dummyBlob,
				status: 200,
			});
			return of(dummyResponse).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.getPromotionReportSummaryExportData(promoReportSummaryDataExportRequestDto);
  }

	public exportPromoReportSummaryServices(promoReportSummaryDataExportRequestDto: PromoReportSummaryDataExportRequestDto) : Observable<HttpResponse<Blob>>  {
		if (this.USE_MOCK) {
			// Mock the export
			const dummyBlob = new Blob(['Mocking Dummy promo export summary service data'], {type: 'text/csv'});
			const dummyResponse = new HttpResponse({
				body: dummyBlob,
				status: 200,
			});
			return of(dummyResponse).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.getPromotionReportServiceSummaryExportData(promoReportSummaryDataExportRequestDto);
	}

	public exportPromoReportSummaryServicePurchases(promoReportSummaryDataExportRequestDto: PromoReportSummaryDataExportRequestDto) : Observable<HttpResponse<Blob>>  {
		if (this.USE_MOCK) {
			// Mock the export
			const dummyBlob = new Blob(['Mocking Dummy promo export summary service purchase data'], {type: 'text/csv'});
			const dummyResponse = new HttpResponse({
				body: dummyBlob,
				status: 200,
			});
			return of(dummyResponse).pipe(delay(SERVICE_DELAY));
		}

		return this.pricingServiceApiService.getPromoReportSummaryServicePurchasesExportData(promoReportSummaryDataExportRequestDto);
	}

	//#endregion --- Promo Discount Report Data ---

	//#region --- Data Transformation ---

	private transformPromoDiscountDataItemToPromoDiscount(promoDiscountDataItem: PromoDiscountDataItem): PromoDiscountItem {
		const promoDiscountItem = new PromoDiscountItem();
		promoDiscountItem.promo_discount_id = promoDiscountDataItem.id;
		promoDiscountDataItem.collector_id = '1';
		promoDiscountItem.promo_discount_detail_item.promo_price_reduction_id = promoDiscountDataItem.promo_discount_type_id;
		promoDiscountItem.promo_discount_detail_item.promo_category_id = promoDiscountDataItem.promo_category_id;
		promoDiscountDataItem.eligibility_filter_id = null;
		promoDiscountItem.promo_discount_detail_item.name = promoDiscountDataItem.name;
		promoDiscountItem.promo_discount_detail_item.description = promoDiscountDataItem.description;
		promoDiscountItem.promo_discount_detail_item.promo_line_item_message = promoDiscountDataItem.line_item_message;
		promoDiscountItem.promo_discount_status_id = promoDiscountDataItem.promo_discount_status_id;
		promoDiscountItem.published_date = promoDiscountDataItem.published_date;
		promoDiscountItem.promo_discount_detail_item.auto_enlist_customers = promoDiscountDataItem.auto_enlist;
		promoDiscountItem.promo_discount_detail_item.promo_code = promoDiscountDataItem.promo_code;
		promoDiscountItem.promo_discount_detail_item.gl_code = promoDiscountDataItem.gl_code;
		promoDiscountDataItem.goal_or_marketing_message = null;
		promoDiscountItem.promo_discount_detail_item.promo_start_date = promoDiscountDataItem.start_date;
		promoDiscountItem.promo_discount_detail_item.promo_end_date = promoDiscountDataItem.end_date;
		promoDiscountDataItem.service_usage_count = 1;
		promoDiscountItem.promo_discount_detail_item.promo_billing_frequency_id = promoDiscountDataItem.price_type_id;
		promoDiscountItem.promo_discount_detail_item.waive_activation_pro_rata = promoDiscountDataItem.waive_activation_pro_rata;
		promoDiscountItem.promo_discount_detail_item.promo_reduction_type_id = promoDiscountDataItem.adjustment_type_id;
		promoDiscountItem.promo_discount_detail_item.promo_reduction_amount = promoDiscountDataItem.adjustment_value;
		promoDiscountItem.published_date = promoDiscountDataItem.published_date;
		promoDiscountItem.promo_discount_detail_item.promo_period_type_id = 1;
		promoDiscountItem.promo_discount_detail_item.promo_period_length = promoDiscountDataItem.period_length;
		promoDiscountItem.promo_discount_detail_item.category_query_type_id = promoDiscountDataItem.category_query_type_id;

		return promoDiscountItem;
	}

	private transformToPromoCustomerServiceDto(fullServices: IFullService[]): IPromoCustomerService[] {
		return fullServices.map((fullService: IFullService) => ({
			id: fullService.service.id,
			customer: {
				full_name: fullService.customer.full_name,
				email: fullService.customer.email,
			},
			area: {
				name: fullService.area.name,
				area_status: fullService.area.area_status,
			},
			premise: {
				full_address: fullService.premise.full_address,
			},
			service: {
				id: fullService.service.id,
				status: fullService.service.status,
			},
			isp_product: {
				name: fullService.isp_product.name,
			},
			area_status_class: getAreaStatusClass(fullService.area.area_status),
			service_status_class: getServiceStatusClass(fullService.service.status),
		}));
	}

	//#endregion --- Data Transformation ---

	//#region --- Seed Data ---

	public seedPromoDiscountStatusData(): void {
		const promoDiscountStatusList: PromoDiscountStatusItem[] = [
			{ id: TPromoStatus.Active,   name: 'Active' },
			{ id: TPromoStatus.FutureDated, name: 'Future Dated' },
			{ id: TPromoStatus.Draft,    name: 'Draft' },
			{ id: TPromoStatus.Deleted,  name: 'Deleted' },
			{ id: TPromoStatus.Expired,  name: 'Expired' },
		];
		promoDiscountStatusList.forEach(mapping => {
			this.tableCacheService.set(TABLE_PROMOTION_DISCOUNT_STATUS, mapping.id, mapping);
		});

	}

	//#endregion --- Seed Data ---

	//#region --- Mock data ---

	private getMockPromoPriceReductionList(): Observable<IPromoPriceReduction[]> {
		const promoPriceReductionList: PromoPriceReductionItem[] = [
			{id: 1, code: 'Promotion', description: 'Promotion'},
			{id: 2, code: 'Discount', description: 'Discount'},
			{id: 3, code: 'Bolt-On', description: 'Bolt-On'},
		];
		promoPriceReductionList.sort((a, b) => a.code.localeCompare(b.code));

		promoPriceReductionList.forEach((promoPriceReduction: IPromoPriceReduction) => {
			this.tableCacheService.set(TABLE_PROMO_PRICE_REDUCTION, promoPriceReduction.id, promoPriceReduction);
		});
		return of(promoPriceReductionList);
	}

	private getMockPromoBillingFrequencyList(): Observable<IPromoBillingFrequency[]> {
		const promoBillingFrequencyList: IPromoBillingFrequency[] = [
			{id: 1, code: 'OnceOff', description: 'Once Off'},
			{id: 2, code: 'Monthly', description: 'Monthly'},
			{id: 3, code: 'Annual', description: 'Annual'},
			{id: 4, code: 'ChangeOfService', description: 'Change Of Service'},
			{id: 5, code: 'ChangeOfISP', description: 'Change Of ISP'},
			{id: 6, code: 'Subscription', description: 'Subscription'},
			{id: 7, code: 'DayBundle', description: 'Day Bundle'},
		];
		promoBillingFrequencyList.sort((a, b) => a.code.localeCompare(b.code));

		promoBillingFrequencyList.forEach((promoBillingFrequency: IPromoBillingFrequency) => {
			this.tableCacheService.set(TABLE_PROMO_BILLING_FREQUENCY, promoBillingFrequency.id, promoBillingFrequency);
		});

		return of(promoBillingFrequencyList);
	}

	private getMockPromoCategoryList(): Observable<IPromoCategory[]> {
		// Fetch the Promo Category List
		const promoCategoryList: IPromoCategory[] = [
			{
				id: 1, category_name: 'ACP Discount', line_item_description: 'ACP Discount',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 2, category_name: 'Billing Issue - Set nr of Months', line_item_description: 'Billing Issue',
				benefit_count_applicable: true, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 3, category_name: 'Billing Issue - Open Ended', line_item_description: 'Billing Issue',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 4, category_name: 'Bulk Uptake Discount', line_item_description: 'Bulk Uptake Discount',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 5, category_name: 'Bulk Uptake Promo', line_item_description: 'Bulk Uptake Promo',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 1, price_type_id: 2,
			},
			{
				id: 6, category_name: 'Employee Discount', line_item_description: 'Employee Discount',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 7, category_name: 'Free Month', line_item_description: 'Free Month',
				benefit_count_applicable: true, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 8, category_name: 'Promo Free Month', line_item_description: 'Free Month',
				benefit_count_applicable: true, query_type_id: 1, promo_discount_type_id: 1, price_type_id: 2,
			},
			{
				id: 9, category_name: 'Historic Discount', line_item_description: '',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 10, category_name: 'Holiday Package', line_item_description: 'Holiday Package',
				benefit_count_applicable: true, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 11,
				category_name: 'Monthly Installation Waiver - for installation pay-off service combo prices only',
				line_item_description: 'Monthly Installation Waiver',
				benefit_count_applicable: false,
				query_type_id: 1,
				promo_discount_type_id: 2,
				price_type_id: 2,
			},
			{
				id: 12, category_name: 'Non-profit Discount', line_item_description: 'Non-profit Discount',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 13, category_name: 'Other - Set nr of Months', line_item_description: '',
				benefit_count_applicable: true, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 14, category_name: 'Other - Open Ended', line_item_description: '',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 15, category_name: 'Promotion - Open Ended', line_item_description: 'Promotional Discount',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 1, price_type_id: 2,
			},
			{
				id: 16, category_name: 'Promotion - Set nr of Months', line_item_description: 'Promotional Discount',
				benefit_count_applicable: true, query_type_id: 1, promo_discount_type_id: 1, price_type_id: 2,
			},
			{
				id: 17, category_name: 'Retention - Set nr of Months', line_item_description: 'Retention Discount',
				benefit_count_applicable: true, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 18, category_name: 'Retention - Open Ended', line_item_description: 'Retention Discount',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 19, category_name: 'Service Credit - Set nr of Months', line_item_description: 'Service Credit',
				benefit_count_applicable: true, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 20, category_name: 'Service Credit - Open Ended', line_item_description: 'Service Credit',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 21, category_name: 'Static Ip - Bolt-on', line_item_description: 'Static Ip',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 22,
				category_name: 'Monthly Static Ip Removal - for static ip/service combo prices only',
				line_item_description: 'Static Ip Removed',
				benefit_count_applicable: false,
				query_type_id: 1,
				promo_discount_type_id: 2,
				price_type_id: 2,
			},
			{
				id: 23, category_name: 'Veteran Discount', line_item_description: 'Veteran Discount',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 24, category_name: 'Voip - Bolt-on', line_item_description: 'Voip',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 25,
				category_name: 'Monthly Voip Removal - for voip/service combo prices only',
				line_item_description: 'Voip Fee Removed',
				benefit_count_applicable: false,
				query_type_id: 1,
				promo_discount_type_id: 2,
				price_type_id: 2,
			},
			{
				id: 26, category_name: 'Day-Bundle - Set nr of Months', line_item_description: 'Day-Bundle Discount',
				benefit_count_applicable: true, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 8,
			},
			{
				id: 27, category_name: 'Day-Bundle - Set nr of Months', line_item_description: 'Day-Bundle Promotion',
				benefit_count_applicable: true, query_type_id: 1, promo_discount_type_id: 1, price_type_id: 8,
			},
			{
				id: 28, category_name: 'Installation/Once Off Discount', line_item_description: 'Installation Discount',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 1,
			},
			{
				id: 29, category_name: 'Day-Bundle - Upfront', line_item_description: 'Upfront Discount',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 1, price_type_id: 8,
			},
			{
				id: 30, category_name: 'Recurring - Upfront', line_item_description: 'Upfront Discount',
				benefit_count_applicable: false, query_type_id: 1, promo_discount_type_id: 2, price_type_id: 2,
			},
			{
				id: 34, category_name: 'Bolt-On - Upfront', line_item_description: 'Bolt-On - Upfront',
				benefit_count_applicable: false, query_type_id: 2, promo_discount_type_id: 3, price_type_id: 2,
			},
		];
		promoCategoryList.sort((a, b) => a.category_name.localeCompare(b.category_name));

		promoCategoryList.forEach((promoCategory: IPromoCategory) => {
			this.tableCacheService.set(TABLE_PROMO_CATEGORY, promoCategory.id, promoCategory);
		});

		return of(promoCategoryList);
	}

	private getMockPromoReductionTypeList(): Observable<IPromoReductionType[]> {
		const promoReductionTypeList: IPromoReductionType[] = [
			{id: 1, code: 'Subtract', description: 'Adjustment by Subtraction'},
			{id: 2, code: 'Substitute', description: 'Adjustment by Substition'},
			{id: 3, code: 'Percentage', description: 'Adjustment by Percentage'},
			{id: 4, code: 'NA', description: 'Not Applicable'},
			{id: 5, code: 'Addition', description: 'Adjustment by Addition'},
		];
		promoReductionTypeList.sort((a, b) => a.description.localeCompare(b.description));

		promoReductionTypeList.forEach((promoReductionType: IPromoReductionType) => {
			this.tableCacheService.set(TABLE_PROMO_REDUCTION_TYPE, promoReductionType.id, promoReductionType);
		});

		return of(promoReductionTypeList);
	}

	private getMockPromoPeriodTypeList(): Observable<IPromoPeriodType[]> {
		const promoPeriodTypeList: IPromoPeriodType[] = [
			{id: 1, name: 'Monthly'},
			{id: 2, name: 'Count'},
		];

		promoPeriodTypeList.sort((a, b) => a.name.localeCompare(b.name));

		promoPeriodTypeList.forEach((promoPeriodType: IPromoPeriodType) => {
			this.tableCacheService.set(TABLE_PROMO_PERIOD_TYPE, promoPeriodType.id, promoPeriodType);
		});

		return of(promoPeriodTypeList);
	}

	private getMockPromoCodeUsageList(): Observable<IPromoCodeUsage[]> {
		const promoCodeUsageList: IPromoCodeUsage[] = [
			{id: '1507017c-2bd1-466b-8827-9b7e67c1358a', name: 'One Time Use'},
			{id: '4089ce6b-3778-41f7-9756-78122f352164', name: 'Multiple Use'},
		];
		promoCodeUsageList.sort((a, b) => a.name.localeCompare(b.name));

		promoCodeUsageList.forEach((promoCodeUsage: IPromoCodeUsage) => {
			this.tableCacheService.set(TABLE_PROMO_CODE_USAGE, promoCodeUsage.id, promoCodeUsage);
		});

		return of(promoCodeUsageList);
	}

	private getMockPromoAppliedByList(): Observable<IPromoAppliedBy[]> {
		const promoAppliedByList: IPromoAppliedBy[] = [
			{id: '2f5f92aa-ee11-4609-91f9-06809d15b74d', name: 'Customer'},
			{id: '2e05188d-7877-48d8-9767-901c8bb34b76', name: 'Sales Agent'},
		];
		promoAppliedByList.sort((a, b) => a.name.localeCompare(b.name));

		promoAppliedByList.forEach((promoAppliedBy: IPromoAppliedBy) => {
			this.tableCacheService.set(TABLE_PROMO_APPLIED_BY, promoAppliedBy.id, promoAppliedBy);
		});

		return of(promoAppliedByList);
	}

	private getMockPromoAreaList(): Observable<PromoAreaTreeItem[]> {
		let areaTreeList: PromoAreaTreeItem[] = [
			{
				children: [
					{
						children: [],
						id: "4058bf01-22d9-4d80-80ec-37263bd71e33",
						name: "Albuquerque OLT 1",
						has_children: false,
					},
				],
				id: "e67e463c-8069-4618-903e-c445f9344402",
				name: "Albuquerque",
				has_children: true,
			},
		];

		areaTreeList.forEach((area) => {
			this.tableCacheService.set(TABLE_PROMO_AREA, area.id, area);
		});

		return of(areaTreeList)
	}

	private getMockPromoProductList(): Observable<IPromoProduct[]> {
		const promoProductList: IPromoProduct[] = [
			{id: '4ca6a1af-7e60-4460-9e74-e15efa455f78', name: '1 Gig '},
			{id: 'be17c24f-ea1f-4718-94e2-100f832c8a3a', name: '1 Gig (Legacy)'},
			{id: 'fb14f74b-6bb1-4d18-b053-deb4a46ffe43', name: '1 Gig Dedicated'},
			{id: 'f67ac2b6-f981-4345-a0f1-81c4a72c7e42', name: '1 Gig with Phone Line'},
			{id: 'abdafa2f-c6d5-48f1-8be3-67b5b2568836', name: '100 Dedicated'},
			{id: 'ac5dbee5-88f7-4925-9dfe-3a9a0bac6c6e', name: '100 Mbps Business'},
			{id: '0c6a75d0-305a-4d14-a318-1478847b9c93', name: '100 Mbps Business with Phone Line'},
			{id: 'acf5e1d4-69f5-4b7b-bbfc-03b65a07ddb7', name: '1Gig Business '},
			{id: '27055b4b-d709-4fef-8fce-4e4461d9b4dd', name: '250 Mbps'},
			{id: 'ad0b8efa-20ed-41e2-bfcf-d48761ca82f8', name: '250 Mbps '},
			{id: '78069fc1-21df-4fd1-b6fc-d72bcc76b069', name: '250 Mbps  -  $ 10 p/m over 24 months'},
			{id: '37f59585-577c-4cef-ac49-a79a45b3094e', name: '250 Mbps Monthly Installation Fee with Phone Line'},
			{id: '3ab229a5-7bca-4c29-8334-d5de6ceaaca1', name: '250 Mbps with Phone Line'},
			{id: 'd16d76ce-8b12-4df1-91db-1848efcdbd44', name: '250 Mbps: Monthly Installation Fee'},
			{id: 'ab1f25da-ac0e-487c-a071-2e2e7071b423', name: '250MB including VOIP with no install fee'},
			{id: '6ddf668e-1e13-4649-8ba3-960dc9bf36bc', name: '300 Dedicated'},
			{id: '0d796544-89ee-4637-a2f9-0bd9576d29e1', name: '300 Mbps Business'},
			{id: '88a24d29-b0d5-4fea-acaa-039ae56a7ec1', name: '500 Dedicated'},
			{id: '0f7b40d6-5b0a-4471-a18b-f190fb5955ca', name: '500 Mbps Business'},
			{id: '2561fcf9-3a23-4046-a5bb-e174c575f44a', name: 'Avington - 1 Gig Ultra'},
			{id: '05cb072f-f921-4ab9-8b79-3eb986aff48c', name: 'Backhaul'},
			{id: '8a75c70c-beb1-48e6-b214-e7c4b5215a65', name: 'Delete'},
			{id: 'ef3e2334-0b2d-422c-bd3a-4160dddc5c1a', name: 'Fiber Ready (No Active Services)'},
			{id: '257cfee1-3b7d-407e-8dce-545a7eb14a2b', name: 'Fiber to the Business'},
			{id: '85e35e0f-8e00-4590-9214-6741903185e0', name: 'Fiber to the Home 50/50'},
			{id: '3be8e61a-550b-4090-bc9d-0c8db6a360e0', name: 'FTTB - Enterprise 100/100'},
			{id: '1d32d261-8c38-4ad1-917d-8384904066c9', name: 'FTTB - Enterprise 1000/1000'},
			{id: 'a6e31752-ea11-4d4d-bf7d-758e4bbd7a36', name: 'FTTB - Enterprise 1000/1000- Duplicate- Delete please'},
			{id: '931fc5bd-9fad-4903-9aa1-9606b5ed65ef', name: 'FTTB - Enterprise 300/300'},
			{id: 'ecbe2c2a-1215-41f6-8ea3-89fa011e26fc', name: 'FTTB - Enterprise 500/500'},
			{id: '458b41e4-f117-4ca9-ac95-96d131a3bd53', name: 'FTTB 100Mb/100Mb -Voice'},
			{id: '895883c1-c834-4da2-a266-42668ecc3c95', name: 'FTTB 100Mb/Voice'},
			{id: '6e90477c-98a7-417c-96d4-b8571e05ec4d', name: 'FTTB 50/50'},
			{id: 'fb4a57f0-a014-49b6-ab91-42021cdcd89d', name: 'FTTB-SMB 100/100'},
			{id: '2499e1fb-410c-4d93-b490-c5547ae7ab29', name: 'FTTB-SMB 1000/1000'},
			{id: '3575f51d-742a-4413-9add-dc50ee268f10', name: 'FTTB-SMB 300/300'},
			{id: 'dab4c0f9-2073-4b86-a9b2-2937e4ca2e00', name: 'FTTB-SMB 500/500'},
			{id: 'a35e2486-c34c-4aca-b71b-fd34fab10f8c', name: 'FTTH 1000'},
			{id: 'dbf71560-52bd-4696-a47f-dc2e234d1408', name: 'FTTH 1000/1000'},
			{id: 'c78b076d-189f-4f3a-83b7-502a9ff83fe3', name: 'FTTH 1000/1000 New'},
			{id: '1085edbb-22f6-4439-b8b3-2ef97863ac41', name: 'FTTH 250/250'},
			{id: '01841340-4477-4a2f-b327-1e5a49f8b364', name: 'FTTH 250/250 with Installation Fee'},
			{id: '7863a4dd-efd9-4f66-89b9-ccf5b2c65431', name: 'FTTH 250/250-Archived'},
			{id: 'dce19f5f-963e-44c2-abc1-3bd204462e44', name: 'FTTH 50/50'},
			{id: '71531e66-7936-4fdc-a4d7-1d0a13ee089d', name: 'FTTH: Employee Benefit Home Service'},
			{id: '82904a7d-995a-46db-962f-122e8cd42661', name: 'FTTH: Employee Benefit Home Service (No Charge)'},
			{id: '51c9d13c-3194-4702-9dd4-5952ac800fea', name: 'Internal Only Test'},
			{id: '7aff025c-3d49-43cd-ab70-9027b37bf2e5', name: 'INTERNAL PRODUCT'},
			{id: 'fdec6244-c9b6-417d-94a4-35c722c1d5f9', name: 'NID Only'},
			{id: '271cc0de-dfbc-453f-a52d-3e5d16e11440', name: 'Portal Fee'},
			{id: '938a5ecd-f1e1-4262-aad5-65789da4f7a9', name: 'Quarter Gig with $200 Installation Fee'},
			{id: 'b03ab5f0-84ef-452f-9a25-81b03206e56e', name: 'Zero Rated Services'},
		];

		promoProductList.sort((a, b) => a.name.localeCompare(b.name));

		promoProductList.forEach((promoProduct) => {
			this.tableCacheService.set(TABLE_PROMO_PRODUCT, promoProduct.id, promoProduct);
		});

		return of(promoProductList);
	}

	private getMockPromoBillingRuleList(): Observable<IPromoBillingRule[]> {
		const promoBillingRuleList: IPromoBillingRule[] = [
			{
				id: 1,
				name: 'Monthly',
				// charges_activation_pro_rata: null,
				// charges_installation : null,
				// has_upfront : null,
				// billing_scheme_product_type : null,
				// has_splits : null,
			},
			{
				id: 2,
				name: 'Once-off',
				// charges_activation_pro_rata: null,
				// charges_installation : null,
				// has_upfront : null,
				// billing_scheme_product_type : null,
				// has_splits : null,
			},
		];
		promoBillingRuleList.sort((a, b) => a.name.localeCompare(b.name));

		promoBillingRuleList.forEach((promoBillingRule) => {
			this.tableCacheService.set(TABLE_PROMO_BILLING_RULE, promoBillingRule.id, promoBillingRule);
		});

		return of(promoBillingRuleList);
	}

	private getMockPromoServiceStatusList(): Observable<IPromoServiceStatus[]> {
		const promoServiceStatusList: IPromoServiceStatus[] = [
			{id: '1', name: 'Service Status 1'},
			{id: '2', name: 'Service Status 2'},
			{id: '3', name: 'Service Status 3'},
			{id: '4', name: 'Service Status 4'},
		];
		promoServiceStatusList.sort((a, b) => a.name.localeCompare(b.name));

		promoServiceStatusList.forEach((promoServiceStatus) => {
			this.tableCacheService.set('PromoServiceStatus', promoServiceStatus.id, promoServiceStatus);
		});
		return of(promoServiceStatusList);
	}

	private initPromoDiscountData(): void {
		const data: PromoDiscountDataItem[] = [
			new PromoDiscountDataItem({
				id: '8ec194d4-2ecf-4a29-8800-88b9a4a711fc',
				name: '1Gig Under 1K',
				promo_code: 'GIGFORLESS',
				start_date_value: new Date(2022, 1, 21),
				end_date_value: new Date(2022, 1, 31),
				service_usage_count: 17,
				promo_discount_status_id: TPromoStatus.Active,
				status: 'Active',
				collector_id: '1',
				promo_discount_type_id: 1,
				promo_category_id: 5,
				eligibility_filter_id: '1',
				description: '1Gig Under 1K - Description 1',
				line_item_message: '1Gig Under 1K -Line Item Message 1',
				published_date: new Date(2022, 1, 19),
				auto_enlist: false,
				gl_code: '1000000-000',
				goal_or_marketing_message: '1Gig Under 1K -Goal or Marketing Message 1',
				price_type_id: 2,
				price_type_name: 'Price Type Name 1',
				waive_activation_pro_rata: true,
				adjustment_type_id: 1,
				adjustment_type_name: 'Adjustment Type Name 1',
				adjustment_value: 10,
				period_length: 1,
				collector_name: 'Collector Name 1',
				promo_discount_type_name: 'Discount Type Name 1',
				promo_category_name: 'Category Name 1',
				category_query_type_id: 1,
			}),
			new PromoDiscountDataItem({
				id: '6ec29e26-feec-43ac-a5e1-f09756472a26',
				name: 'April 2021 NoJoke Promo',
				promo_code: 'NOJOKE',
				start_date_value: new Date(2021, 3, 1),
				service_usage_count: 2017,
				promo_discount_status_id: TPromoStatus.Draft,
				end_date_value: new Date(2021, 4, 30),
				status: 'In-active',
				collector_id: '2',
				promo_discount_type_id: 1,
				promo_category_id: 5,
				eligibility_filter_id: '2',
				description: 'April 2021 NoJoke Promo - Description 2',
				line_item_message: 'April 2021 NoJoke Promo -Line Item Message 2',
				published_date: new Date(2022, 0, 19),
				auto_enlist: true,
				gl_code: '1000000-000',
				goal_or_marketing_message: 'April 2021 NoJoke Promo -Goal or Marketing Message 2',
				price_type_id: 2,
				period_length: 1,
				category_query_type_id: 1,

				price_type_name: 'Price Type Name 2',
				waive_activation_pro_rata: true,
				adjustment_type_id: 1,
				adjustment_type_name: 'Adjustment Type Name 2',
				adjustment_value: 10,
				collector_name: 'Collector Name 2',
				promo_discount_type_name: 'Discount Type Name 2',
				promo_category_name: 'Category Name 2',
			}),
			new PromoDiscountDataItem({
				id: 'e6698a2d-f030-4279-8209-eb891053688e',
				name: '1 Month Free',
				promo_code: '!MONTH',
				start_date_value: new Date(2024, 0, 21),
				end_date_value: new Date(2024, 0, 31),
				service_usage_count: null,
				promo_discount_status_id: TPromoStatus.Draft,
				status: 'Draft',
				collector_id: '3',
				promo_discount_type_id: 1,
				promo_category_id: 5,
				eligibility_filter_id: '3',
				description: '1 Month Free - Description 3',
				line_item_message: '1 Month Free -Line Item Message 3',
				published_date: new Date(2022, 1, 19),
				auto_enlist: true,
				gl_code: '1000000-000',
				goal_or_marketing_message: '1 Month Free -Goal or Marketing Message 3',
				price_type_id: 2,
				period_length: 1,
				category_query_type_id: 1,

				price_type_name: 'Price Type Name 1',
				waive_activation_pro_rata: true,
				adjustment_type_id: 3,
				adjustment_type_name: 'Adjustment Type Name 3',
				adjustment_value: 10,
				collector_name: 'Collector Name 3',
				promo_discount_type_name: 'Discount Type Name 3',
				promo_category_name: 'Category Name 3',
			}),
			new PromoDiscountDataItem({
				id: '8a1d1cfa-e9e2-4ad5-bd14-f999832bc5a0',
				name: 'Valentine Day',
				promo_code: 'SWEETHEART',
				start_date_value: new Date(2024, 2, 1),
				service_usage_count: 2000000,
				promo_discount_status_id: TPromoStatus.Deleted,
				end_date_value: new Date(2024, 2, 14),
				status: 'Deleted',
				collector_id: '4',
				promo_discount_type_id: 1,
				promo_category_id: 5,
				eligibility_filter_id: '4',
				description: 'Valentine Day - Description 4',
				line_item_message: 'Valentine Day -Line Item Message 4',
				published_date: new Date(2024, 1, 31),
				auto_enlist: true,
				gl_code: '1000000-000',
				goal_or_marketing_message: 'Valentine Day -Goal or Marketing Message 4',
				price_type_id: 2,
				period_length: 1,
				category_query_type_id: 1,

				price_type_name: 'Price Type Name 4',
				waive_activation_pro_rata: true,
				adjustment_type_id: 1,
				adjustment_type_name: 'Adjustment Type Name 4',
				adjustment_value: 10,
				collector_name: 'Collector Name 4',
				promo_discount_type_name: 'Discount Type Name 4',
				promo_category_name: 'Category Name 4',
			}),
			new PromoDiscountDataItem({
				id: '5b613e48-0f8d-438e-9426-9c77a3039504',
				name: 'Static IP',
				promo_code: generateRandomString(6),
				service_usage_count: 2000000,
				promo_discount_status_id: TPromoStatus.Draft,
				start_date_value: new Date(2025, 5, 1),
				start_date: formatDate(new Date(2025, 5, 1), 'yyyy-MM-dd', 'en-US'),
				end_date_value: new Date(2025, 5, 21),
				end_date: formatDate(new Date(2025, 5, 21), 'yyyy-MM-dd', 'en-US'),
				status: 'Draft',
				collector_id: '4',
				promo_discount_type_id: 3,					// Bolt-On
				promo_category_id: 5,
				eligibility_filter_id: '4',
				description: 'Bolt-on Static IP',
				line_item_message: 'Static IP',
				published_date: null,
				auto_enlist: false,
				gl_code: '1000000-000',
				goal_or_marketing_message: 'Static IP -Goal or Marketing Message 4',
				price_type_id: 2,
				period_length: 1,
				category_query_type_id: 1,

				price_type_name: 'Price Type Name 4',
				waive_activation_pro_rata: true,
				adjustment_type_id: 4,
				adjustment_type_name: 'Adjustment by Addition',
				adjustment_value: 10,
				collector_name: 'Collector Name 4',
				promo_discount_type_name: 'Bolt-On',
				promo_category_name: 'Category Name Bolt-On',
			}),
		];

		data.sort((a, b) => a.name.localeCompare(b.name));

		data.forEach((promoDiscountDataItem) => {
			const promoDiscountItem = this.transformPromoDiscountDataItemToPromoDiscount(promoDiscountDataItem);
			this.tableCacheService.set(TABLE_PROMOTION_DISCOUNT, promoDiscountItem.promo_discount_id, promoDiscountItem);
		});
	}

	private getMockPromoReportSummaryData(_searchRequest: PromoReportSearchRequestDto): Observable<IPagedResponse<PromoSummaryDto>> {
		const resultData: PromoSummaryDto[] = [];
		let promoSummaryDto = new PromoSummaryDto();
		promoSummaryDto.promo_discount_id = '8ec194d4-2ecf-4a29-8800-88b9a4a711fc';
		promoSummaryDto.promo_name = '1Gig Under 1K';
		promoSummaryDto.promo_price_reduction_name = 'Discount';
		promoSummaryDto.promo_discount_category_id = 1;
		promoSummaryDto.promo_discount_category_name = 'ACP Discount';
		promoSummaryDto.product_price = 900;
		promoSummaryDto.promo_adjustment = -45;
		promoSummaryDto.applied_promo_adjustment = -45;
		promoSummaryDto.final_amount =  855;
		promoSummaryDto.reported_usage_count = 9;
		promoSummaryDto.total_usage_count = 1000;
		promoSummaryDto.remaining_usage_count = 800;
		promoSummaryDto.promo_status_id = TPromoStatus.Active;
		promoSummaryDto.promo_status_name = 'Active';
		resultData.push(promoSummaryDto);

		return of({
			items: resultData,
			page: 1,
			count: resultData.length,
			total: resultData.length,
		});

	}

	private getMockPromoReportSummaryServicesData(_searchRequest: PromoReportSearchRequestDto): Observable<IPagedResponse<PromoSummaryServiceDto>> {
		const resultData: PromoSummaryServiceDto[] = [];
		let recordItem = new PromoSummaryServiceDto();
		recordItem.promo_discount_id = '8ec194d4-2ecf-4a29-8800-88b9a4a711fc';
		recordItem.promo_name = '1Gig Under 1K';
		recordItem.promo_price_reduction_name = 'Discount';
		recordItem.promo_discount_category_id = 1;
		recordItem.promo_discount_category_name = 'ACP Discount';
		recordItem.product_price = 100;
		recordItem.promo_adjustment = -15;
		recordItem.applied_promo_adjustment = -15;
		recordItem.final_amount =  285;
		recordItem.reported_usage_count = 3;
		recordItem.total_usage_count = 300;
		recordItem.remaining_usage_count = 200;

		recordItem.service_id = 'a6743155-b265-4579-a45a-12f51eddcbdc';
		recordItem.product_name = '1 Gig Dedicated';
		recordItem.service_status_name = 'Active';
		recordItem.area_name = 'New York';

		recordItem.customer_full_name = 'Jane Doe';
		recordItem.customer_email = 'jane.doe@gmail.com';
		resultData.push(recordItem);

		recordItem = new PromoSummaryServiceDto();
		recordItem.promo_discount_id = '8ec194d4-2ecf-4a29-8800-88b9a4a711fc';
		recordItem.promo_name = '1Gig Under 1K';
		recordItem.promo_price_reduction_name = 'Discount';
		recordItem.promo_discount_category_id = 1;
		recordItem.promo_discount_category_name = 'ACP Discount';
		recordItem.product_price = 200;
		recordItem.promo_adjustment = -10;
		recordItem.applied_promo_adjustment = -10;
		recordItem.final_amount = 190;
		recordItem.reported_usage_count = 3;
		recordItem.total_usage_count = 300;
		recordItem.remaining_usage_count = 200;

		recordItem.service_id = '4e451211-cbcb-4f12-b674-508863abb641';
		recordItem.product_name = '1Gig Business';
		recordItem.service_status_name = 'Active';
		recordItem.area_name = 'New York';

		recordItem.customer_full_name = 'Jane Doe';
		recordItem.customer_email = 'jane.doe@gmail.com';
		resultData.push(recordItem);

		recordItem = new PromoSummaryServiceDto();
		recordItem.promo_discount_id = '8ec194d4-2ecf-4a29-8800-88b9a4a711fc';
		recordItem.promo_name = '1Gig Under 1K';
		recordItem.promo_price_reduction_name = 'Discount';
		recordItem.promo_discount_category_id = 1;
		recordItem.promo_discount_category_name = 'ACP Discount';
		recordItem.product_price = 200;
		recordItem.promo_adjustment = -10;
		recordItem.applied_promo_adjustment = -10;
		recordItem.final_amount =  190;
		recordItem.reported_usage_count = 2;
		recordItem.total_usage_count = 200;
		recordItem.remaining_usage_count = 200;

		recordItem.service_id = 'ca416849-4ceb-4b60-8b0e-a874483b4449';
		recordItem.product_name = '1 Gig Dedicated';
		recordItem.service_status_name = 'Active';
		recordItem.area_name = 'New York';
		recordItem.customer_full_name = 'Silly Sally';
		recordItem.customer_email = 'silly.sally@gmail.com';
		resultData.push(recordItem);

		recordItem = new PromoSummaryServiceDto();
		recordItem.promo_discount_id = '8ec194d4-2ecf-4a29-8800-88b9a4a711fc';
		recordItem.promo_name = '1Gig Under 1K';
		recordItem.promo_price_reduction_name = 'Discount';
		recordItem.promo_discount_category_id = 1;
		recordItem.promo_discount_category_name = 'ACP Discount';
		recordItem.product_price = 400;
		recordItem.promo_adjustment = -20;
		recordItem.applied_promo_adjustment = -20;
		recordItem.final_amount =  380;
		recordItem.reported_usage_count = 6;
		recordItem.total_usage_count = 400;
		recordItem.remaining_usage_count = 600;

		recordItem.service_id = 'fbd43b0e-a34d-47bc-ba9e-54dd78d568c3';
		recordItem.product_name = '1 Gig Dedicated';
		recordItem.service_status_name = 'Active';
		recordItem.area_name = 'New York';
		recordItem.customer_full_name = 'King Henry';
		recordItem.customer_email = 'king.henry@gmail.com';
		resultData.push(recordItem);

		resultData.sort((a, b) => a.customer_full_name.localeCompare(b.customer_full_name));

		return of({
			items: resultData,
			page: 1,
			count: resultData.length,
			total: resultData.length,
		});

	}

	private getMockPromoReportSummaryServicePurchasesData(_searchRequest: PromoReportSearchRequestDto): Observable<IPagedResponse<PromoSummaryServicePurchaseDto>> {
		const resultData: PromoSummaryServicePurchaseDto[] = [];
		let recordItem = new PromoSummaryServicePurchaseDto();
		recordItem.purchase_date = new Date(2022, 1, 25);
		recordItem.purchase_id = 'f61328d6-3d07-4fb2-9db4-c80da406c697';
		recordItem.invoice_number = '282'
		// recordItem.amount = 100;
		recordItem.purchase_status_id = 1;
		recordItem.purchase_status_name = 'In-arrears';

		recordItem.promo_discount_id = '8ec194d4-2ecf-4a29-8800-88b9a4a711fc';
		recordItem.promo_name = '1Gig Under 1K';
		recordItem.promo_price_reduction_name = 'Discount';
		recordItem.promo_discount_category_id = 1;
		recordItem.promo_discount_category_name = 'ACP Discount';
		recordItem.product_price = 100;
		recordItem.promo_adjustment = -5;
		recordItem.applied_promo_adjustment = 0;
		recordItem.final_amount =  100;
		recordItem.reported_usage_count = 3;
		recordItem.total_usage_count = 300;
		recordItem.remaining_usage_count = 200;

		recordItem.service_id = 'a6743155-b265-4579-a45a-12f51eddcbdc';
		recordItem.product_name = '1 Gig Dedicated';
		recordItem.service_status_name = 'Active';
		recordItem.area_name = 'New York';

		recordItem.customer_full_name = 'Jane Doe';
		recordItem.customer_email = 'jane.doe@gmail.com';
		resultData.push(recordItem);

		recordItem = new PromoSummaryServicePurchaseDto();
		recordItem.purchase_date = new Date(2022, 2, 25);
		recordItem.purchase_id = '50ba1d51-af70-4ab8-8fe4-26f170796c55';
		recordItem.invoice_number = '285'
		// recordItem.amount = 95;
		recordItem.purchase_status_id = 2;
		recordItem.purchase_status_name = 'Paid';

		recordItem.promo_discount_id = '8ec194d4-2ecf-4a29-8800-88b9a4a711fc';
		recordItem.promo_name = '1Gig Under 1K';
		recordItem.promo_price_reduction_name = 'Discount';
		recordItem.promo_discount_category_id = 1;
		recordItem.promo_discount_category_name = 'ACP Discount';
		recordItem.product_price = 100;
		recordItem.promo_adjustment = -5;
		recordItem.applied_promo_adjustment = -5;
		recordItem.final_amount =  95;
		recordItem.reported_usage_count = 4;
		recordItem.total_usage_count = 301;
		recordItem.remaining_usage_count = 200;

		recordItem.service_id = 'a6743155-b265-4579-a45a-12f51eddcbdc';
		recordItem.product_name = '1 Gig Dedicated';
		recordItem.service_status_name = 'Active';
		recordItem.area_name = 'New York';

		recordItem.customer_full_name = 'Jane Doe';
		recordItem.customer_email = 'jane.doe@gmail.com';
		resultData.push(recordItem);

		recordItem = new PromoSummaryServicePurchaseDto();
		recordItem.purchase_date = new Date(2022, 3, 25);
		recordItem.purchase_id = 'd394d0ed-24ae-4d68-a2ce-c84bb39d1e93';
		recordItem.invoice_number = '290'
		// recordItem.amount = 95;
		recordItem.purchase_status_id = 2;
		recordItem.purchase_status_name = 'Paid';

		recordItem.promo_discount_id = '8ec194d4-2ecf-4a29-8800-88b9a4a711fc';
		recordItem.promo_name = '1Gig Under 1K';
		recordItem.promo_price_reduction_name = 'Discount';
		recordItem.promo_discount_category_id = 1;
		recordItem.promo_discount_category_name = 'ACP Discount';
		recordItem.product_price = 100;
		recordItem.promo_adjustment = -5;
		recordItem.applied_promo_adjustment = -5;
		recordItem.final_amount =  95;
		recordItem.reported_usage_count = 4;
		recordItem.total_usage_count = 301;
		recordItem.remaining_usage_count = 200;

		recordItem.service_id = 'a6743155-b265-4579-a45a-12f51eddcbdc';
		recordItem.product_name = '1 Gig Dedicated';
		recordItem.service_status_name = 'Active';
		recordItem.area_name = 'New York';

		recordItem.customer_full_name = 'Jane Doe';
		recordItem.customer_email = 'jane.doe@gmail.com';
		resultData.push(recordItem);

		resultData.sort((a, b) => a.customer_full_name.localeCompare(b.customer_full_name));

		return of({
			items: resultData,
			page: 1,
			count: resultData.length,
			total: resultData.length,
		});

	}

	private getMockPromoReportSummaryServicePurchaseInfoData(
		promoSummaryServicePurchaseDto : PromoSummaryServicePurchaseDto,
		searchRequest: PromoReportSearchRequestDto,
	): Observable<PromoServicePurchaseInfoDto> {
		const resultData = new PromoServicePurchaseInfoDto();
		resultData.purchase_id = searchRequest.purchase_ids[0];
		resultData.purchase_date = promoSummaryServicePurchaseDto.purchase_date;
		resultData.total_amount = promoSummaryServicePurchaseDto.final_amount;
		resultData.purchase_status_id = promoSummaryServicePurchaseDto.purchase_status_id;
		resultData.purchase_status_name = promoSummaryServicePurchaseDto.purchase_status_name;

		const purchaseLines : PromoServicePurchaseDetailLineDto[] = [];
		let purchaseLine = new PromoServicePurchaseDetailLineDto();
		purchaseLine.purchase_line_id = '876ee15d-2cca-4d0b-afee-db0bc21a2385';
		purchaseLine.description = 'Line Fee';
		purchaseLine.quantity = 1;
		purchaseLine.amount_per_quantity = 100;
		purchaseLine.amount = 100;
		purchaseLine.purchase_line_type_id = 2;
		purchaseLine.purchase_line_type_name = 'Monthly';
		purchaseLine.promo_discount_id = null;
		purchaseLine.promo_discount_name = null;
		purchaseLine.is_hidden = false;
		purchaseLines.push(purchaseLine);

		purchaseLine = new PromoServicePurchaseDetailLineDto();
		purchaseLine.purchase_line_id = 'da6387b7-6e72-4117-8f03-0384ee33ca6a';
		purchaseLine.description = 'Static Ip';
		purchaseLine.quantity = 1;
		purchaseLine.amount_per_quantity = 5;
		purchaseLine.amount = 5;
		purchaseLine.purchase_line_type_id = 2;
		purchaseLine.purchase_line_type_name = 'Amount Adjustment';
		purchaseLine.promo_discount_id = promoSummaryServicePurchaseDto.promo_discount_id;
		purchaseLine.promo_discount_name = promoSummaryServicePurchaseDto.promo_name;
		purchaseLine.is_hidden = false;
		purchaseLines.push(purchaseLine);

		resultData.promo_purchase_lines = purchaseLines;

		return of(resultData);
	}

	private getMockServicePromoWithData(searchRequest: PromoReportSearchRequestDto): Observable<IPagedResponse<PromoSummaryWithDataDto>> {
		const record : PromoSummaryWithDataDto = new PromoSummaryWithDataDto();
		record.promo_discount_id = '7e734ba3-cfae-40a6-85e5-27119c539614';
		record.promo_name = 'MY Test Promo';
		record.promo_adjustment = -10;
		record.applied_promo_adjustment = -5;
		record.final_amount = 95;
		record.reported_usage_count = 1;               // Usage count of the promo discount for the report period
		record.total_usage_count = 1;                  // Total usage count of the promo discount
		record.remaining_usage_count= 99;              // Estimated remaining usage count of the promo discount

		record.promo_status_id = 2;
		record.promo_status_name = 'active';

		const service = new PromoSummaryServiceWithDataDto();
		service.service_id = searchRequest.service_id;
		service.promo_discount_id = record.promo_discount_id;
		service.customer_full_name = 'Silly Sally';
		service.customer_email = 'sally@gmail.com';
		service.product_name = '1 Gig Dedicated';
		service.service_status_name = 'Active';
		service.area_name = 'New York';

		service.exhaustion_reason = 'Test comment';
		service.activation_date = new Date(2025, 4, 10, 0, 0, 0, 0);
		service.exhaustion_date = new Date(2025, 6, 10, 0, 0, 0, 0);
		service.can_remove = true;

		record.services = [service];

		const invoice = new PromoSummaryNestedInvoiceDto();

		invoice.promo_adjustment = -10;
		invoice.applied_promo_adjustment = -5;
		invoice.final_amount = 95;
		invoice.total_usage_count = 1;                  // Total usage count of the promo discount

		invoice.purchase_id = 'c74787fe-1c6f-4871-8c87-7608075473f8';
		invoice.purchase_date = new Date(2025, 4, 16, 0, 0, 0, 0);
		invoice.invoice_number = '20250416-001';
		invoice.final_amount = 95;
		invoice.product_price = 100;

		service.invoices.push(invoice);

		const result : IPagedResponse<PromoSummaryWithDataDto> = {
			items: [record],
			page: 1,
			count: 1,
			total: 1,
		}

		return of(result)
	}

	private getMockPromoSelectionList() : Observable<IPromotionDiscount[]> {
		const promoSelectionList: IPromotionDiscount[] = [
			{	promo_discount_id: '8ec194d4-2ecf-4a29-8800-88b9a4a711fc', name: '1Gig Under 1K' },
			{	promo_discount_id: '6ec29e26-feec-43ac-a5e1-f09756472a26', name: 'April 2021 NoJoke Promo' },
			{	promo_discount_id: 'e6698a2d-f030-4279-8209-eb891053688e', name: '1 Month Free' },
			{	promo_discount_id: '8a1d1cfa-e9e2-4ad5-bd14-f999832bc5a0', name: 'Valentine Day' },
		];
		promoSelectionList.sort((a, b) => a.name.localeCompare(b.name));
		return of(promoSelectionList);
	}

	private getMockPromoSelectionListToAddService() : Observable<IPromotionDiscountForService[]> {
		const promoSelectionList: IPromotionDiscountForService[] = [
			{	promo_discount_id: '8ec194d4-2ecf-4a29-8800-88b9a4a711fc', name: '1Gig Under 1K',
				promo_start_date: new Date(2025, 4, 1), promo_end_date: new Date(2025, 6, 30)},
			{	promo_discount_id: '6ec29e26-feec-43ac-a5e1-f09756472a26', name: 'April 2021 NoJoke Promo',
				promo_start_date: new Date(2025, 5, 1), promo_end_date: new Date(2025, 6, 30)},
			{	promo_discount_id: 'e6698a2d-f030-4279-8209-eb891053688e', name: '1 Month Free',
				promo_start_date: new Date(2025, 6, 1), promo_end_date: new Date(2025, 7, 31)},
			{	promo_discount_id: '8a1d1cfa-e9e2-4ad5-bd14-f999832bc5a0', name: 'Valentine Day',
				promo_start_date: new Date(2025, 5, 15), promo_end_date: new Date(2025, 7, 31)},
		];
		promoSelectionList.sort((a, b) => a.name.localeCompare(b.name));
		return of(promoSelectionList);
	}

	private getMockPromoRemovalReasonList() : Observable<IPromoRemovalReason[]> {
		const promoRemovalReasonList: IPromoRemovalReason[] = [
			{name: 'Customer Request'},
			{name: 'Promo Terms Violated'},
			{name: 'Promo Exhausted'},
			{name: 'Service Cancelled'},
			{name: 'Service Suspended'},
			{name: 'Service Transferred'},
			{name: 'Service Terminated'},
			{name: 'Other'},
		];

		promoRemovalReasonList.sort((a, b) => a.name.localeCompare(b.name));
		return of(promoRemovalReasonList);
	}

	//#endregion --- Mock
}
